module.exports = __webpack_public_path__ + "img/-1440x900.7cd5e68a.jpg";